<template>
  <dialog-card title="" :actions="actions" :handler="handlerClick" titleClass="pb-0" ref="card">
    <v-row>
      <v-col cols="12" md="6">
        <v-card-title>
          Zakończ obsługę
        </v-card-title>
        <v-card-subtitle class="">
          {{ siteName }}
        </v-card-subtitle>
        <v-card-text>
          <v-text-field autofocus class="mt-0" label="Komentarz końcowy" v-model="result.message"
            @keyup.enter.stop="onEnter">
          </v-text-field>
          <v-textarea class="mt-0" label="Dodatkowy komentarz ( Shift+Enter : nowa linia )" v-model="result.comment"
            rows="1" auto-grow @keydown.enter.exact.prevent="onEnter"
            @keydown.enter.shift.exact.prevent="result.comment += '\n'">
          </v-textarea>
        </v-card-text>
      </v-col>
      <!-- <v-divider class="my-3"></v-divider> -->
      <v-col cols="12" md="6">
        <v-card-title>
          Opłata
        </v-card-title>
        <div class="payment-list-scrollable scrollable-list-with-shadows with-border-left">
          <payment-list :payments="paymentListData" @payment-changed="onPaymentChanged" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-divider></v-divider>
        <v-card-title class="py-0">
          <v-checkbox v-model="result.note" label="Pozostaw notatkę" hide-details></v-checkbox>
        </v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-select
          label="Rodzaj notatki"
          v-model="selectedNote"
          :items="notes"
          :item-text="(item) => item.name"
          :disabled="!result.note"
          return-object
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <VueCtkDateTimePicker
          v-bind="$attrs"
          v-model="expiresNoteAt"
          :dark="$vuetify.theme.dark"
          color="$vuetify.theme.currentTheme.primary"
          :hint="selectedNote.endLabel"
          :minDate="minExpiresAt"
          :disabled="!result.note"
          label="Do odwołania"
          format="YYYY-MM-DD HH:mm"
          formatted="dddd, DD MMMM YYYY HH:mm"
        ></VueCtkDateTimePicker>
      </v-col>
    </v-row>
  </dialog-card>
</template>

<script>
// import _ from 'lodash'
import { UserTaskType, canEditCost } from '@/store/modules/task'
import { Note } from "@/store/modules/note";
import { addHours } from "date-fns";
import { sync } from "vuex-pathify";

export default {
  name: "CloseTaskDialog",
  data: () => ({
    actions: {
      false: "Anuluj",
      true: {
        color: "success",
        text: "OK"
      },
    },
    selectedNote: {
      endLabel: "Zakończ",
    },
    expiresNoteAt: null,
    notes: Note.all(),
    result: {
      payments: [],
      message: null,
      comment: null
    }
  }),
  mounted() {
    this.result.message = this.message
    this.result.comment = this.comment
    this.result.payments = this.event.tasks.map((task) => {
      return {
        task: task,
        token: {
          value: task.details?.cost?.token ?? 0,
          name: task.details?.cost?.name ?? ""
        },
      };
    });
  },
  watch: {
    "results.payments.token": {
      handler: function (val, oldVal) {
        console.log("token", val, oldVal);
      },
      deep: true,
    },
    selectedNote() {
      if (this.selectedNote.duration == null) {
        this.expiresNoteAt = null;
      } else {
        this.expiresNoteAt = this.$options.filters?.localDateTime(addHours(new Date(), this.selectedNote.duration))
      }
    },
  },
  computed: {
    user: sync('user.profile'),
    siteName() {
      return this.$options.filters.siteFullName(this.event?.site);
    },
    patrolTasks() {
      return this.event.tasks.filter((task) => {
        return task.task_type == UserTaskType.PATROL;
      });
    },
    minExpiresAt() {
      return this.$options.filters?.localDateTime(addHours(new Date(), 1))
    },
    paymentListData() {
      return this.result.payments.map((p) => {
        return {
          task: p.task,
          taskId: p.task.id,
          user: this.firstAssigneeUser(p.task),
          token: p.token,
          readonly: !canEditCost(p.task)
        };
      });
    }
  },
  props: {
    event: {
      type: Object,
      default: () => null
    },
    message: {
      type: String,
      default: () => null
    },
    comment: {
      type: String,
      default: () => null
    }
  },
  methods: {
    onPaymentChanged({ index, value }) {
      const oldValue = this.result.payments[index].token?.value ?? 0;
      const newValue = value?.value ?? 0;
      this.result.payments[index].updated = oldValue !== newValue;
      this.result.payments[index].token = value;
    },
    firstAssigneeUser(task) {
      if (!task?.assignees?.length) {
        return null;
      }
      return task.assignees[0].user;
    },
    onEnter() {
      this.$refs.card.$refs.actions.trigger(true)
    },
    handlerClick(res, action) {
      if (!action.key) {
        this.$emit('submit', action.key)
      }
      const valid = this.rules ? this.$refs.input.validate() : true
      if (!valid) {
        this.$refs.input.focus()
        return false
      }
      if (this.result.note) {
        this.result.note = this.selectedNote
        this.result.note.expiresAt = this.expiresNoteAt
      }
      this.$emit('submit', action.key ? this.result : action.key)
    }
  },
};
</script>

<style scoped>
.payment-list-scrollable {
  max-height: 400px;
}
</style>
